import React, {Component} from "react"
import PropTypes from "prop-types"
import {_countTotalLogin} from "../../../../services/apis/AdminUserServices";
import {Link} from "react-router-dom";
import MemberDetails from "./MemberDetails";

class TeamMaster extends Component {
    state = {
        totalLogin: 0,
        collapse: false
    }

    componentDidMount() {
        this._fetchTotalLogin()
    }

    _toggleCollapse = () => {
        this.setState(prevState => ({
            collapse: !prevState.collapse
        }))
    }

    _fetchTotalLogin = async () => {
        const {owner} = this.props
        const {_id} = owner

        const {success, data} = await _countTotalLogin(_id)

        if (success) {
            this.setState({totalLogin: data})
        }
    }

    render() {
        const {owner} = this.props
        const {totalLogin, collapse} = this.state
        const {_id, email, profile} = owner
        const {name} = profile

        return (
            <div>
                <table>
                    <tbody>
                    <tr>
                        <td><Link to={`/a/users/${_id}`}>{name}</Link></td>
                        {/*<td>({totalLogin}) {email}*/}
                        {/*    <span className='extend-arrow' onClick={this._toggleCollapse}>&#x25BC;</span>*/}
                        {/*</td>*/}
                    </tr>
                    </tbody>
                </table>
                {/*{*/}
                {/*    collapse && <MemberDetails member={owner}/>*/}
                {/*}*/}
            </div>
        )
    }
}

TeamMaster.propTypes = {
    owner: PropTypes.object.isRequired
}

export default TeamMaster


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/team/TeamMaster.js